import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Rocket } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Vakken',
    href: '#vakken'
  }, {
    name: 'Hoe het werkt',
    href: '#hoe-het-werkt'
  }, {
    name: 'Technologie',
    href: '#technologie'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <header className="fixed top-0 left-0 right-0 z-50 flex flex-col" data-id="element-162">
      {/* RC Banner - Editorial feel */}
      <div className="bg-slate-950 text-white px-4 py-2 text-[11px] font-bold text-center flex items-center justify-center gap-2 tracking-wide" data-id="element-163">
        <Rocket className="w-3.5 h-3.5 text-orange-400" data-id="element-164" />
        <span data-id="element-165">
          Meester djay is momenteel in Release Candidate (v3.0). We leggen de
          laatste hand aan de perfecte leerervaring.
        </span>
      </div>

      {/* Main Navigation */}
      <nav className={`transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-4'}`} data-id="element-166">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167">
          <div className="flex justify-between items-center" data-id="element-168">
            {/* Logo */}
            <a href="#" className="flex items-center gap-2.5 group" data-id="element-169">
              <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center text-white font-bold text-sm transition-transform" data-id="element-170">
                md
              </div>
              <span className="text-lg font-extrabold tracking-tight text-slate-950" data-id="element-171">
                Meester djay
              </span>
            </a>

            {/* Desktop Links */}
            <div className="hidden md:flex items-center gap-8" data-id="element-172">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-bold text-slate-600 hover:text-orange-500 transition-colors" data-id="element-173">
                  {link.name}
                </a>)}
              <a href="https://demo.meesterdjay.nl" target="_blank" rel="noopener noreferrer" className="bg-orange-500 hover:bg-orange-600 text-white px-5 py-2 rounded-lg text-sm font-bold transition-colors" data-id="element-174">
                Probeer de Demo
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button className="md:hidden p-2 text-slate-600 hover:text-orange-500 transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-175">
              {isMobileMenuOpen ? <X className="w-5 h-5" data-id="element-176" /> : <Menu className="w-5 h-5" data-id="element-177" />}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-178">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-b border-slate-100 shadow-lg overflow-hidden" data-id="element-179">
            <div className="px-4 pt-2 pb-6 flex flex-col gap-2" data-id="element-180">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-sm font-bold text-slate-600 hover:text-orange-500 py-3 border-b border-slate-50" data-id="element-181">
                  {link.name}
                </a>)}
              <a href="https://demo.meesterdjay.nl" target="_blank" rel="noopener noreferrer" className="bg-orange-500 text-white px-4 py-3 rounded-lg text-sm font-bold text-center mt-4" data-id="element-182">
                Probeer de Demo
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}